module.exports = __webpack_public_path__ + "static/media/18_CALCINHA_LATERAL_DRAPEADA_ESTAMPADA_02.bb1d864e.jpg";